import 'react-on-rails-pro/registerDefaultRSCProvider/client';
import ReactOnRails from 'react-on-rails-pro/client';
import ProductSearchClient from '../../startup/ProductSearchClient.client.tsx';

ReactOnRails.register({ProductSearchClient});